import Vue from "vue";
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { ApiToken } from '../utils/ApiToken'
import { gethlSignature, RefreshToken, GetIndex } from '../api/index'
import { getCookie, setCookie } from '../utils/_handleCookie'
import {
    wxShares
} from "../utils/wxShare"
import qrcodeData from '@/assets/json/qrcode'

NProgress.configure({ showSpinner: false })

Vue.use(VueRouter)


const Home = () =>
    import ('@/views/Home/index.vue')
const Index = () =>
    import ('@/views/Index/index.vue')
const CloudGuide = () =>
    import ('@/views/CloudGuide/index.vue')
const Exhibition = () =>
    import ('@/views/Exhibition/index.vue')
const Survey = () =>
    import ('@/views/Survey/index.vue')
const Live = () =>
    import ('@/views/Live/index.vue')


const Personal = () =>
    import ('@/views/Personal/index.vue')
const CloudPhoto = () =>
    import ('@/views/CloudPhoto/index.vue')
const Register = () =>
    import ('@/views/Register/index.vue')
const ScanCode = () =>
    import ('@/views/ScanCode/index.vue')


const originalPush = VueRouter.prototype.push
    // 重写了原型上的push方法，统一的处理了错误信息
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [{
        path: '/',
        redirect: '/Home/Index'
    },
    {
        path: '/Home',
        name: 'Home',
        component: Home,
        meta: {
            title: '首页',
            activePath: '/Home'
        },
        children: [{
                path: '/Home/Index',
                name: 'Index',
                component: Index,
                meta: {
                    title: '首页',
                    activePath: '/Home/Index'
                },
            },
            {
                path: '/Home/CloudGuide',
                name: 'CloudGuide',
                component: CloudGuide,
                meta: {
                    title: '云导览',
                    activePath: '/Home/CloudGuide'
                },
            },
            {
                path: '/Home/Exhibition',
                name: 'Exhibition',
                component: Exhibition,
                meta: {
                    title: '新品展示',
                    activePath: '/Home/Exhibition'
                },
            },
            {
                path: '/Home/Survey',
                name: 'Survey',
                component: Survey,
                meta: {
                    title: '有奖调研',
                    activePath: '/Home/Survey'
                },
            },
            {
                path: '/Home/Live',
                name: 'Live',
                component: Live,
                meta: {
                    title: '直播',
                    activePath: '/Home/Live'
                },
            },
            {
                path: '/Home/Personal',
                name: 'Personal',
                component: Personal,
                meta: {
                    title: '个人中心',
                    activePath: '/Home/Personal'
                },
            },
            {
                path: '/Home/CloudPhoto',
                name: 'CloudPhoto',
                component: CloudPhoto,
                meta: {
                    title: '现场速递',
                    activePath: '/Home/CloudPhoto'
                },
            }
        ]
    }, {
        path: '/Register',
        name: 'Register',
        component: Register,
        meta: {
            title: '注册页',
            activePath: '/Register'
        },
    }, {
        path: '/ScanCode',
        name: 'ScanCode',
        component: ScanCode,
        meta: {
            title: '注册页',
            activePath: '/ScanCode'
        },
    }
]

const router = new VueRouter({
    // mode: 'hash', //默认 带#号
    mode: 'history', //不带#号

    //子域名下文件夹
    base: ApiToken.Cpath,
    routes
})

// 路由守卫 登录前使用
router.beforeEach((to, from, next) => {
    let track = to.query.track ? to.query.track : '';
    let tracksList = []
    qrcodeData.map(item => {
        tracksList.push(item.track)
    })
    if (tracksList.findIndex(item => item === Number(track)) === -1) {
        to.query.track = tracksList[0]
    }
    // console.log(document.cookie)
    // UserLogin('15318701598').then(res => {
    //     console.log(res)
    // })
    // if (window.sessionStorage.getItem('sigUrl') != ApiToken.shareUrl + '/Home/Index') {
    //         window.sessionStorage.setItem('sigUrl', ApiToken.shareUrl + '/Home/Index')
    //         console.log(window.location.href.split('?')[1])
    //         if (window.location.href.split('?')[1]) {
    //             window.location.href = ApiToken.shareUrl + '/Home/Index?' + window.location.href.split('?')[1]
    //         } else {
    //             window.location.href = ApiToken.shareUrl + '/Home/Index?track=10366'
    //         }
    // }
    if (getCookie('QC_Token2025')) {
        if (getCookie('gongBoOpenId2025')) {
            RefreshToken().then(res => {
                if (res.Status == 1) {
                    setCookie('QC_Token2025', res.Data)
                    next()
                } else {
                    next()
                }
            })
        } else {
            next()
        }
    } else {
        if (/(micromessenger)/i.test(navigator.userAgent)) {
            //是否电脑微信或者微信开发者工具
            GetIndex(window.location.href).then(res => {
                window.location.href = res.Data
            })
            next()
        } else {
            // alert('其他浏览器')
            if (getCookie('gongBoOpenId2025')) {
                RefreshToken().then(res => {
                    if (res.Status == 1) {
                        setCookie('QC_Token2025', res.Data)
                        next()
                    } else {
                        next()
                    }
                })
            } else {
                next()
            }
        }
    }
})




//history模式下，分享值记录最后一次进入的页面(需要授权时可能会进行回调跳转页面)
router.afterEach((to, from, next) => { // 跳转后
    window.scrollTo(0, 0);

    let track = to.query.track ? to.query.track : '';
    let utm_source = to.query.utm_source ? to.query.utm_source : '';
    let utm_medium = to.query.utm_medium ? to.query.utm_medium : '';
    let utm_campaign = to.query.utm_campaign ? to.query.utm_campaign : '';
    let utm_content = to.query.utm_content ? to.query.utm_content : '';
    let se_sr = to.query.se_sr ? to.query.se_sr : '';
    let se_md = to.query.se_md ? to.query.se_md : '';
    let se_ct = to.query.se_ct ? to.query.se_ct : '';
    setTimeout(() => {
        const ShareConfig = {
            title: '云游2025工博会',
            desc: '了不起的未来工业',
            imgUrl: 'https://staticdn.ht-s.cn/se/ciif/2025/common/wxShare.png',
            link: ApiToken.shareUrl + '/Home/Index?track=' + track + "&utm_source=" + utm_source + "&utm_medium=" + utm_medium + "&utm_campaign=" + utm_campaign + "&utm_content=" + utm_content + "&se_sr=" + se_sr + "&se_md=" + se_md + "&se_ct=" + se_ct, //正式
        }

        gethlSignature().then(res => {
            wxShares(res, ShareConfig)
        })
    }, 300)
})

export default router